module.exports = __webpack_public_path__ + "img/ddx.cd2e481c.svg";